import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;


pdfMake.vfs = pdfFonts.pdfMake.vfs

export const GenerateUserPDFReport = (userData: any) => {
  const docDefinition = {
    pageMargins: [40, 60, 40, 60] as [number, number, number, number],
    content: [
      {
        text: "Performance Rating Report",
        style: "mainHeader",
        alignment: "center" as const,
        margin: [0, 0, 0, 20] as [number, number, number, number],
      },

      {
        table: {
          widths: ["30%", "70%"],
          body: [
            [
              { text: "Employee Name:", style: "infoLabel" },
              { text: userData.displayName, style: "infoValue" },
            ],
            [
              { text: "Department:", style: "infoLabel" },
              { text: userData.departmentName, style: "infoValue" },
            ],
            [
              { text: "Job Title:", style: "infoLabel" },
              { text: userData.jobTitle, style: "infoValue" },
            ],
            [
              { text: "Overall Performance:", style: "infoLabel" },
              { text: userData.finalOverallAverage, style: "scoreHighlight", bold: true },
            ],
          ],
        },
        layout: {
          fillColor: (rowIndex: number) => (rowIndex === 3 ? "#f0f9ff" : "#fafafa"),
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          hLineColor: () => "#e5e7eb",
          vLineColor: () => "#e5e7eb",
          paddingLeft: () => 12,
          paddingRight: () => 12,
          paddingTop: () => 8,
          paddingBottom: () => 8,
        },
        margin: [0, 0, 0, 25] as [number, number, number, number],
      },

      {
        text: "Professional Competency Ratings",
        style: "sectionHeader",
        margin: [0, 10, 0, 10] as [number, number, number, number],
      },
      {
        table: {
          headerRows: 1,
          widths: ["*", "20%"],
          body: [
            [
              { text: "Competency", style: "tableHeader" },
              { text: "Score", style: "tableHeader", alignment: "center" as const },
            ],
            ...Object.entries(userData.templateAverages || {}).map(([key, value], index) => [
              { text: key, style: "tableCell" },
              { text: (Number(value) || 0).toFixed(2), style: "tableCell", alignment: "center" as const, bold: true },
            ]),
          ],
        },
        layout: {
          fillColor: (rowIndex: number) => {
            if (rowIndex === 0) return "#3b82f6"
            return rowIndex % 2 === 0 ? "#ffffff" : "#f9fafb"
          },
          hLineWidth: (i: number, node: any) => (i === 0 || i === 1 || i === node.table.body.length ? 1 : 0.5),
          vLineWidth: () => 0.5,
          hLineColor: () => "#e5e7eb",
          vLineColor: () => "#e5e7eb",
          paddingLeft: () => 12,
          paddingRight: () => 12,
          paddingTop: () => 8,
          paddingBottom: () => 8,
        },
        margin: [0, 0, 0, 20] as [number, number, number, number],
      },

      {
        text: "Core Values Ratings",
        style: "sectionHeader",
        margin: [0, 10, 0, 10] as [number, number, number, number],
      },
      {
        table: {
          headerRows: 1,
          widths: ["*", "20%"],
          body: [
            [
              { text: "Value", style: "tableHeader" },
              { text: "Score", style: "tableHeader", alignment: "center" as const },
            ],
            ...(Object.entries(userData.valueAverages || {}).length
              ? Object.entries(userData.valueAverages || {}).map(([key, value], index) => [
                  { text: key, style: "tableCell" },
                  {
                    text: (Number(value) || 0).toFixed(2),
                    style: "tableCell",
                    alignment: "center" as const,
                    bold: true,
                  },
                ])
              : [
                  [
                    {
                      text: "No value ratings available",
                      colSpan: 2,
                      alignment: "center" as const,
                      style: "emptyCell",
                    },
                    {},
                  ],
                ]),
          ],
        },
        layout: {
          fillColor: (rowIndex: number) => {
            if (rowIndex === 0) return "#10b981"
            return rowIndex % 2 === 0 ? "#ffffff" : "#f9fafb"
          },
          hLineWidth: (i: number, node: any) => (i === 0 || i === 1 || i === node.table.body.length ? 1 : 0.5),
          vLineWidth: () => 0.5,
          hLineColor: () => "#e5e7eb",
          vLineColor: () => "#e5e7eb",
          paddingLeft: () => 12,
          paddingRight: () => 12,
          paddingTop: () => 8,
          paddingBottom: () => 8,
        },
        margin: [0, 0, 0, 20] as [number, number, number, number],
      },

      {
        text: "Leadership Competency Ratings",
        style: "sectionHeader",
        margin: [0, 10, 0, 10] as [number, number, number, number],
      },
      {
        table: {
          headerRows: 1,
          widths: ["*", "20%"],
          body: [
            [
              { text: "Competency", style: "tableHeader" },
              { text: "Score", style: "tableHeader", alignment: "center" as const },
            ],
            ...(Object.entries(userData.leadershipAverages || {}).length
              ? Object.entries(userData.leadershipAverages || {}).map(([key, value], index) => [
                  { text: key, style: "tableCell" },
                  {
                    text: (Number(value) || 0).toFixed(2),
                    style: "tableCell",
                    alignment: "center" as const,
                    bold: true,
                  },
                ])
              : [
                  [
                    {
                      text: "No leadership ratings available",
                      colSpan: 2,
                      alignment: "center" as const,
                      style: "emptyCell",
                    },
                    {},
                  ],
                ]),
          ],
        },
        layout: {
          fillColor: (rowIndex: number) => {
            if (rowIndex === 0) return "#8b5cf6"
            return rowIndex % 2 === 0 ? "#ffffff" : "#f9fafb"
          },
          hLineWidth: (i: number, node: any) => (i === 0 || i === 1 || i === node.table.body.length ? 1 : 0.5),
          vLineWidth: () => 0.5,
          hLineColor: () => "#e5e7eb",
          vLineColor: () => "#e5e7eb",
          paddingLeft: () => 12,
          paddingRight: () => 12,
          paddingTop: () => 8,
          paddingBottom: () => 8,
        },
        margin: [0, 0, 0, 20] as [number, number, number, number],
      },

      {
        text: `Report generated on ${new Date().toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}`,
        style: "footer",
        alignment: "center" as const,
        margin: [0, 30, 0, 0] as [number, number, number, number],
      },
    ],
    styles: {
      mainHeader: {
        fontSize: 24,
        bold: true,
        color: "#1f2937",
      },
      sectionHeader: {
        fontSize: 16,
        bold: true,
        color: "#374151",
      },
      infoLabel: {
        fontSize: 11,
        bold: true,
        color: "#6b7280",
      },
      infoValue: {
        fontSize: 11,
        color: "#1f2937",
      },
      scoreHighlight: {
        fontSize: 14,
        color: "#2563eb",
      },
      tableHeader: {
        fontSize: 11,
        bold: true,
        color: "#ffffff",
        fillColor: "#3b82f6",
      },
      tableCell: {
        fontSize: 10,
        color: "#374151",
      },
      emptyCell: {
        fontSize: 10,
        color: "#9ca3af",
        italics: true,
      },
      footer: {
        fontSize: 9,
        color: "#9ca3af",
        italics: true,
      },
    },
  }

  pdfMake.createPdf(docDefinition).download(`${userData.displayName}_RatingReport.pdf`)
}

